import React from "react";
import { PROJECTS } from "../../data/recent-project.data";
import "./recent-project.css";

// sine straubge skdhfajdh
const RecentProject = () => {
  const projects = [...PROJECTS];

  // some nice things
  return (
    <section className="projects-area bg-color pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src="assets/img/star-icon.png" alt="image" /> Recent Projects
          </span>
          <h2>
            Check Some Of Our Recent Work<span className="overlay-1"></span>
          </h2>
        </div>

        <div className="row projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-item">
              <div className="single-projects-box">
                <div className="image">
                  <img src={project.imageUrl} alt="image" />
                  <a target="_blank" href={project.url} className="link-btn" rel="noreferrer">
                    <i className="bx bx-plus"></i>
                  </a>
                </div>

                <div className="content">
                  <h3>
                    <a target="_blank" href={project.url} rel="noreferrer" style={{ color: "white" }}>
                      {project.title}
                    </a>
                  </h3>
                  <span>{project.solution}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RecentProject;
